import { useEffect, useState } from "react";
import {
  getMillisecondsUntilNextVietnamDay,
  getVietnamDateKey,
} from "./kpiPerDayUtils";

const TODAY_KEY_CHECK_INTERVAL_MS = 5 * 60 * 1000;
const MIDNIGHT_TIMER_BUFFER_MS = 1000;

const useVietnamTodayKey = () => {
  const [todayKey, setTodayKey] = useState(() => getVietnamDateKey());

  useEffect(() => {
    let midnightTimeoutId;

    const refreshTodayKey = () => {
      const nextTodayKey = getVietnamDateKey();
      setTodayKey((currentTodayKey) =>
        currentTodayKey === nextTodayKey ? currentTodayKey : nextTodayKey
      );
    };

    const scheduleMidnightRefresh = () => {
      midnightTimeoutId = window.setTimeout(() => {
        refreshTodayKey();
        scheduleMidnightRefresh();
      }, getMillisecondsUntilNextVietnamDay() + MIDNIGHT_TIMER_BUFFER_MS);
    };

    const intervalId = window.setInterval(
      refreshTodayKey,
      TODAY_KEY_CHECK_INTERVAL_MS
    );
    scheduleMidnightRefresh();

    return () => {
      window.clearInterval(intervalId);
      window.clearTimeout(midnightTimeoutId);
    };
  }, []);

  return todayKey;
};

export default useVietnamTodayKey;
